import { GET } from '@/utils/axios'

export const getTargetLink = async (organization, qrCode) =>
  await GET(`/qrCode/getTargetLink/${organization}/${qrCode}`)
